import { defineRouting } from "next-intl/routing";

export const locales = ["pt", "en", "es", "fr", "de", "it", "zh", "ja", "ar", "ko", "pt-PT"] as const;
export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: "pt",
  localePrefix: "as-needed",
  localeCookie: {
    name: "NEXT_LOCALE",
    maxAge: 31536000,
    sameSite: "lax",
  },
});

export const rtlLocales: Locale[] = ["ar"];

export function isRTL(locale: Locale): boolean {
  return rtlLocales.includes(locale);
}
